import { deleteApp, getApps, initializeApp } from 'firebase/app'
import { initializeFirestore } from 'firebase/firestore'
import DataService from './services/DataService'

export let firebaseProject: string | undefined

export const firebaseInit = async (forceReload?: boolean) => {
  const project = await DataService.getInitiationSettings()
  firebaseProject = project.name

  if (forceReload && getApps().length > 0) {
    await deleteApp(getApps()[0])
  }

  if (getApps().length === 0) {
    const app = initializeApp(project.config)
    initializeFirestore(app, {
      ignoreUndefinedProperties: true,
    })
  }
}
